import printer from '../assets/community/3dPrinter.png';
import cnc from '../assets/community/cnc.png';
import drill from '../assets/community/drill.png';
import idesign from '../assets/community/idesign.png';
// import knowledgeSharing from '../assets/community/knowledgeSharing.png';

const inventory = 
    [
        {
            "title": "3D Printer",
            "tagline": "FDM, Build Volume:300mmx300mmx300mm",  
            "icon": printer
        },
        {
            "title": "CNC Router",
            "tagline": "Bed Size: 500mmx500mm835mm",
            "icon": cnc
        },
        {
            "title": "Power Tools",
            "tagline": "Wood & Metal",
            "icon": drill
        },
        {
            "title": "Industrial Design Consult",
            "tagline": "1hr Consultation",
            "icon": idesign
        },
        // {
        //     "title": "Knowledge Share",
        //     "tagline": "Case by case",
        //     "icon": knowledgeSharing
        // }
    ]

export default inventory;